export const customers: TableModule = {
    name: "customers",
    route: "spa.system.organisations.customers",
    defaultOrder: {
        column: "created_at",
        direction: "desc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }],
    columns: [
        {
            name: "id",
            sortable: true,
            width: "w-[100px]"
        },
        {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "plan",
            feature: "billingSystem"
        },
        {
            name: "active",
            sortable: true
        }
    ],
    filters: [
        {
            name: "id",
            column: "organisations.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "organisations.name",
            type: "string"
        },
        {
            name: "active",
            column: "organisations.active",
            type: "boolean"
        },
        {
            name: "email",
            column: "organisations.email",
            type: "string"
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        }
    ]
}
